module.exports = __webpack_public_path__ + "img/history2016.86ef6010.jpg";